//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ChooseDevice',
  data: function data() {
    return {
      activeDevice: null,
      devices: ['apple', 'garmin', 'coros', 'suuntoV2', 'polar'],
    };
  },
  props: {
    clickedDevice: {
      type: String,
      default: () => null,
    },
  },
  computed: {
    garminIsActive() {
      return this.activeDevice === 'garmin';
    },
    // suuntoIsActive() {
    //   return this.activeDevice === 'suunto';
    // },
    suuntoV2IsActive() {
      return this.activeDevice === 'suuntoV2';
    },
    polarIsActive() {
      return this.activeDevice === 'polar';
    },
    corosIsActive() {
      return this.activeDevice === 'coros';
    },
    appleIsActive() {
      return this.activeDevice === 'apple';
    },
    show() {
      if (this.clickedDevice) {
        const filtered = this.devices.filter(device => device === this.clickedDevice);
        this.handleDeviceSelection(filtered[0]);
        return filtered;
      }
      return this.devices;
    },
  },
  methods: {
    handleDeviceSelection(type) {
      this.activeDevice = type;
      this.$emit('device-type', type);
    },
  },
};
